module.exports = __webpack_public_path__ + "img/section4.40019330.svg";